import CarbonClient from "../CarbonClient";

//GET
export async function getGeneratedReports(id: string | string[]) {
  const response = await CarbonClient.get(`/api/BuildingProject/reportblobs/buildingproject/${id}`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function getDownloadReport(id: string | string[], buildingprojectId: string | string[]) {
  const response = await CarbonClient.get(
    `/api/BuildingProject/reportblobs/buildingproject/${buildingprojectId}/download/${id}`,
    {
      responseType: "blob",
    }
  );

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export async function getEmissionSnapshot(id: string | string[]) {
  const response = await CarbonClient.get(`/api/Emission/emissionsnapshot/buildingproject/${id}`);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

export type GetDashboardDataRequest = {
  models: [];
};

export async function getDashboardData(buildingProjectId: string | string[], payload: GetDashboardDataRequest) {
  const response = await CarbonClient.post(`/api/BuildingProject/dashboard/${buildingProjectId}`, payload);

  if (response.status === 200) {
    return response.data;
  } else {
    return { status: response.status, message: response.statusText };
  }
}

//PUT

//POST

//DELETE
